import {
  NotificationProfessionState,
  NotificationState,
} from "@/domains/notification/constants/notificationState";

export default function isProfessionNotification(
  notification: NotificationState,
): notification is NotificationProfessionState {
  return (notification as NotificationProfessionState).profession !== undefined;
}
